module.exports = __webpack_public_path__ + "img/logo.1353f32b.svg";